import { render, staticRenderFns } from "./SelectProjectRfi.vue?vue&type=template&id=b8a8fe2e&scoped=true&lang=pug&"
import script from "./SelectProjectRfi.vue?vue&type=script&lang=js&"
export * from "./SelectProjectRfi.vue?vue&type=script&lang=js&"
import style0 from "./SelectProjectRfi.vue?vue&type=style&index=0&id=b8a8fe2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a8fe2e",
  null
  
)

export default component.exports